import styled from 'styled-components';
import muiStyled from '@mui/styles/styled';

import TextField from '@mui/material/TextField';

import { ListItemIcon, Menu } from '@mui/material';
import { VaultButton } from '../../Shared';

export const TagFieldFilter = styled(TextField)`
  input {
    width: 100%,
    padding: 12px !important,
  }
`;

export const TagMenu = styled(Menu)`
  .MuiCheckbox-indeterminate {
    color: black !important;
  }
  .MuiListSubheader-sticky {
    background-color: white;
  }
  .MuiFormControl-root {
    padding-top: 14px;
    padding-bottom: 10px;
    padding-left: 14px;
    padding-right: 14px;
  }
  .MuiList-root {
    padding-bottom: 2px;
  }
  .MuiListItem-root {
    height: 36px;
  }
  .MuiMenuItem-root {
    height: 36px;
  }
  .MuiTypography-root {
    margin: 0;
    font-weight: bold;
}
`;

export const CreateTagButton = styled(VaultButton)`
  padding: 0px;
  font-size: 12px;
  color: #da1717;
  background-color: #ffffff;
`;

export const ListItemIconTest = muiStyled(ListItemIcon)({
  minWidth: 'auto',
});

export const EditTagContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

export const RenameContainer = styled.div`
  display: flex;
  flex-direction: column;
  span {
    padding-top: 10px;
    padding-left: 10px;
  }
  .MuiTextField-root {
    padding: 10px;
  }
  .MuiOutlinedInput-adornedEnd {
    padding-right: 12px;
  }
  .MuiIconButton-label {
    padding: 0px !important;
  }
`;

export const EditText = styled.p`
  font-weight: bold;
  font-size: 12px;
`;
